import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { Toaster } from "sonner";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="App min-h-screen flex flex-col bg-[hsl(var(--bg))]" data-testid="app-root">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "hsl(var(--ink))",
            color: "hsl(var(--bg))",
            border: "1px solid hsl(var(--umber))",
            borderRadius: "2px",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}
